import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/pages/LoginPage.vue'
import { config as appConfig } from '@/config'

// Admin Views
import Dashboard from '@/views/Dashboard.vue'
import ServiceHealth from '@/views/ServiceHealth.vue'
import BetaUsers from '@/views/BetaUsers.vue'
import FeatureFlags from '@/views/FeatureFlags.vue'
import UserFeedback from '@/views/UserFeedback.vue'
import NewsManagement from '@/views/NewsManagement.vue'
import AIPrompts from '@/views/AIPrompts.vue'
import AuditLogs from '@/views/AuditLogs.vue'
import EmailInbox from '@/views/EmailInbox.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { requiresAuth: false }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/service-health',
      name: 'service-health',
      component: ServiceHealth,
      meta: { requiresAuth: true }
    },
    {
      path: '/beta-users',
      name: 'beta-users',
      component: BetaUsers,
      meta: { requiresAuth: true }
    },
    {
      path: '/feature-flags',
      name: 'feature-flags',
      component: FeatureFlags,
      meta: { requiresAuth: true }
    },
    {
      path: '/user-feedback',
      name: 'user-feedback',
      component: UserFeedback,
      meta: { requiresAuth: true }
    },
    {
      path: '/news-management',
      name: 'news-management',
      component: NewsManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/ai-prompts',
      name: 'ai-prompts',
      component: AIPrompts,
      meta: { requiresAuth: true }
    },
    {
      path: '/audit-logs',
      name: 'audit-logs',
      component: AuditLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/email-inbox',
      name: 'email-inbox',
      component: EmailInbox,
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/login'
    }
  ]
})

// Navigation guard with debug logging
router.beforeEach((to, from, next) => {
  // Special handling for login route - clear any stale tokens
  if (to.path === '/login' && from.path === '/') {
    console.log('Navigating to login from root - clearing all tokens')
    // Clear all possible auth tokens
    localStorage.removeItem(appConfig.auth.tokenKey)
    localStorage.removeItem('adminUser')
    localStorage.removeItem('adminToken')
    localStorage.removeItem('token')
    localStorage.removeItem('jwtToken')
    localStorage.removeItem('access_token')
    
    // Also clear sessionStorage
    sessionStorage.clear()
  }
  
  const token = localStorage.getItem(appConfig.auth.tokenKey)
  const isAuthenticated = !!token
  
  console.log('Router Guard Debug:', {
    to: to.path,
    from: from.path,
    tokenKey: appConfig.auth.tokenKey,
    tokenExists: isAuthenticated,
    tokenValue: token ? token.substring(0, 20) + '...' : null,
    requiresAuth: to.meta.requiresAuth
  })
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('Redirecting to login - no auth')
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    console.log('Redirecting to dashboard - already authenticated')
    next('/dashboard')
  } else {
    console.log('Allowing navigation')
    next()
  }
})

export default router